export default __webpack_public_path__ + "static/media/DiferenciaisBG.2e154227.jpg";